import React, { useEffect, useRef } from 'react';
import ThumbnailData from '../models/ThumbnailData';
import ErrorMessage from './ErrorMessage';
import ConfidentialMessage from './ConfidentialMessage';
import { Box, darken, lighten, useTheme } from '@mui/material';

const FileViewer: React.FC<{ thumbnailData: ThumbnailData, printError: string | null }> = ({ thumbnailData, printError }) => {
  const urlRef = useRef(thumbnailData.url);
  const theme = useTheme();
  const textPrimary = theme.palette.text.primary;
  const bgPaper = theme.palette.background.paper;
  const isDark = theme.palette.mode === 'dark';
  const bgLighter = darken(bgPaper, isDark ? 0.0 : 0.06);
  const bgDeeper = lighten(bgPaper, isDark ? 0.08 : 0.0);

  const viewerBackground = isDark ? bgDeeper : bgLighter;
  useEffect(() => {
    urlRef.current = thumbnailData.url;
  }, [thumbnailData.url]);

  useEffect(() => {
    return () => {
      URL.revokeObjectURL(urlRef.current);
    };
  }, []);

  return (
    <Box sx={{ marginTop: 2 }}>
      {thumbnailData.isConfidential && <ConfidentialMessage />}

      {printError && <ErrorMessage message={printError} />}
      {!thumbnailData.isConfidential && (<iframe
        name="file-viewer"
        id="file-viewer"
        src={thumbnailData.url}
        width="100%"
        height="800px"
        title={thumbnailData.title}
        aria-label={`Invoice file: ${thumbnailData.title}`}
        onLoad={(e) => {
          const iframe = e.currentTarget;
          const doc = iframe.contentDocument || iframe.contentWindow?.document;
          if (!doc) {
            return;
          }

          const style = doc.createElement('style');
          style.textContent = `
              :root { }
              body { color:  ${textPrimary} !important; background-color: ${viewerBackground} !important; }
              
              h2, h1, h3, h4, h5, h6 { color: ${textPrimary} !important;}
            `;
          doc.head.appendChild(style);
        }}
      />
      )}
    </Box>
  );
};

export default FileViewer;